import { QueryClient } from '@tanstack/react-query';

// Global mutation retry policy. All mutations in this app must be idempotent
// to be safe under retry. Submit PATCH (questionnaire completion) is the
// motivating example and is idempotent server-side as of the questionnaire
// robustness work — the backend auto-completes on the terminal answer write,
// so a subsequent client PATCH against an already-COMPLETED row returns
// SUCCESS with an empty missing_questions array.
export const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      retry: 2,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 5000),
    },
  },
});
